<template>
  <Error404 ref="error404"></Error404>
</template>

<script>
  import Error404 from "./Error404.vue";

  export default {
    name: "Error404Wrapper",
    components: {
      Error404,
    },
  };
</script>
